import * as ambassadorWixFunctionsV1EditorFunction from './functions-v1-editor-function-editor-functions.http.js';
import * as ambassadorWixFunctionsV1EditorFunctionTypes from './functions-v1-editor-function-editor-functions.types.js';
import * as ambassadorWixFunctionsV1EditorFunctionUniversalTypes from './functions-v1-editor-function-editor-functions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function invokeEditorFunction(): __PublicMethodMetaInfo<
  'POST',
  { functionId: string },
  ambassadorWixFunctionsV1EditorFunctionUniversalTypes.InvokeEditorFunctionRequest,
  ambassadorWixFunctionsV1EditorFunctionTypes.InvokeEditorFunctionRequest,
  ambassadorWixFunctionsV1EditorFunctionUniversalTypes.InvokeEditorFunctionResponse,
  ambassadorWixFunctionsV1EditorFunctionTypes.InvokeEditorFunctionResponse
> {
  const payload = { functionId: ':functionId' } as any;

  const getRequestOptions =
    ambassadorWixFunctionsV1EditorFunction.invokeEditorFunction(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/editor-functions/{functionId}/invoke',
    pathParams: { functionId: 'functionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  EditorFunction as EditorFunctionOriginal,
  InvokeEditorFunctionRequest as InvokeEditorFunctionRequestOriginal,
  InvokeEditorFunctionResponse as InvokeEditorFunctionResponseOriginal,
  InvokeEditorFunctionApplicationErrors as InvokeEditorFunctionApplicationErrorsOriginal,
} from './functions-v1-editor-function-editor-functions.types.js';
